<template>
  <div>
    <AppHeader @refreshPage="init" />
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item :title="$t('new.text10')" name="1">
        <div v-html="$t('new.text11')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text12')" name="2">
        <div v-html="$t('new.text13')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text14')" name="3">
        <div v-html="$t('new.text15')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text16')" name="4">
        <div v-html="$t('new.text17')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text18')" name="5">
        <div v-html="$t('new.text19')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text20')" name="6">
        <div v-html="$t('new.text21')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('add.predict')" name="7">
        <div v-html="$t('new.text74')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text72')" name="8">
        <div v-html="$t('new.text75')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text56') + ' NFT'" name="9">
        <div v-html="$t('new.text76')"></div>
      </el-collapse-item>
      <el-collapse-item :title="$t('new.text57') + ' NFT'" name="10">
        <div v-html="$t('new.text77')"></div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: 'UserQa',
  components: {},
  data() {
    return {
      activeNames: []
    }
  },
  created() {
    let arr = []
    if (this.$route.query && this.$route.query.type) {
      arr.push(this.$route.query.type)
    } else {
      arr.push('1')
    }
    this.activeNames = arr
  },
  methods: {
    init() {},
    handleChange() {}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/qa.vue